import React from 'react'

function deconfig() {
  return (
    <div>deconfig</div>
  )
}

export default deconfig